// Sources allowed to show Autosure branding (header logo, favicon) when newAutosureLogo is on.
// Footer and about-you apply the flag to every source regardless, including white-label partners (AA, VTNZ, GASPY, TFAF).
export const AUTOSURE_BRANDED_SOURCES = ['TFAF_AUTOSURE', 'QUASHED', 'MONEYHUB', 'MYAUTOSHOP'];
